/**
 * Env-gated conversion tracking. Nothing loads unless the IDs are set:
 *   REACT_APP_META_PIXEL_ID   — Meta (Facebook) Pixel
 *   REACT_APP_GOOGLE_TAG_ID   — Google tag (Ads / GA4, e.g. AW-XXXX or G-XXXX)
 * No hardcoded keys. Used for retargeting + ads conversion measurement.
 */

const META_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GTAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID || "";

let initialized = false;

export function initTracking() {
  if (initialized || (!META_ID && !GTAG_ID)) return;
  initialized = true;

  if (META_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_ID);
    window.fbq("track", "PageView");
  }

  if (GTAG_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GTAG_ID);
  }
}

/**
 * track("lead", {type: "seller"}) — fires to whichever pixels are configured.
 * Standard mappings: lead → Meta "Lead" / gtag "generate_lead";
 * booking → Meta "Schedule"; everything else passes through as custom.
 */
export function track(event, params = {}) {
  try {
    if (window.fbq) {
      const metaMap = { lead: "Lead", booking: "Schedule", home_value: "Lead", inquiry: "Lead", saved_search: "CompleteRegistration", shortlist: "AddToWishlist" };
      const name = metaMap[event];
      if (name) window.fbq("track", name, params);
      else window.fbq("trackCustom", event, params);
    }
    if (window.gtag) {
      const gMap = { lead: "generate_lead", booking: "book_appointment", home_value: "generate_lead", inquiry: "generate_lead", saved_search: "sign_up", shortlist: "add_to_wishlist" };
      window.gtag("event", gMap[event] || event, params);
    }
  } catch {
    // Tracking must never break the funnel
  }
}
